import { render, staticRenderFns } from "./ClassroomDetailTabStudentDetail.vue?vue&type=template&id=511785e2&scoped=true"
import script from "./ClassroomDetailTabStudentDetail.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTabStudentDetail.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailTabStudentDetail.vue?vue&type=style&index=0&id=511785e2&prod&lang=stylus&scoped=true"
import style1 from "./ClassroomDetailTabStudentDetail.vue?vue&type=style&index=1&id=511785e2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511785e2",
  null
  
)

export default component.exports